var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.987 3.025c1.22 0 2.213.957 2.213 2.136 0 1.178-.993 2.136-2.213 2.136-1.22 0-2.215-.958-2.215-2.136 0-1.179.994-2.136 2.215-2.136zm0 7.296c-2.95 0-5.348-2.314-5.348-5.16C4.64 2.314 7.037 0 9.987 0c2.948 0 5.346 2.315 5.346 5.161 0 2.846-2.398 5.16-5.346 5.16zm2.177 4.211l2.989 2.886a1.482 1.482 0 01.46 1.07 1.47 1.47 0 01-.46 1.069 1.603 1.603 0 01-2.215 0l-2.94-2.835-2.935 2.835a1.598 1.598 0 01-1.109.442c-.4 0-.8-.148-1.107-.442a1.485 1.485 0 01-.459-1.07 1.474 1.474 0 01.459-1.069l2.989-2.884a10.238 10.238 0 01-3.105-1.242 1.498 1.498 0 01-.692-.94 1.476 1.476 0 01.201-1.145 1.601 1.601 0 012.16-.475 6.992 6.992 0 007.199 0 1.602 1.602 0 012.16.475c.46.705.241 1.64-.491 2.085-.959.581-2.008 1-3.104 1.242v-.002z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ok.d587a930.svg";
export { ForwardRef as ReactComponent };